import React from "react";
import { Page, Text, View, Image } from "@react-pdf/renderer";

import { CSR_CONTRIBUTION_OPTIONS } from "../../../constants/constants";
import CDK_Logo from "../../../images/CDKGlobalWM_BLK.jpg";
import commonStyles from "../PDFStyles/common";
import styles from "../PDFStyles/CSRForm";
import { getFullName, getFormattedDate } from "../../../util/helpers";
import { getDeclarationPlace } from "../../../util/onBoardingDataFilters";

const CSRForm = React.memo(({ candidateDetails }) => {
  const {
    cSRContribution,
    declarationDate,
    declarationPlace
  } = candidateDetails

  const getCSRAmount = csrAmountId => {
    if (csrAmountId) {
      const csrContributionOption = CSR_CONTRIBUTION_OPTIONS.find(
        csrOption => csrOption.id == csrAmountId
      );
      return csrContributionOption.amount;
    }
    return "0";
  };

  return (
    <Page size="A4" style={commonStyles.page}>
      <Image style={commonStyles.cdkLogo} src={CDK_Logo} />
      <Text
        style={{ ...commonStyles.headerTitleWithUnderline, ...styles.title }}
      >
        CSR Contribution Declaration
      </Text>
      <View style={styles.headerinfo}>
        <Text>The Manager</Text>
        <Text>Human Resources</Text>
        <Text>CDK Global (India) Private Limited</Text>
      </View>
      <Text style={styles.subjectText}>
        Sub: Authorization for payroll deduction towards Voluntary CSR
        Contribution
      </Text>
      <Text>Dear Sir,</Text>
      <Text style={styles.mainText}>
        I understand that CDK Global (India) Private Limited supports social and
        charitable causes and that employees can contribute money in support of
        these causes.
      </Text>
      <Text style={styles.mainText}>
        I hereby authorize CDK Global (India) Private Limited to deduct INR
        <Text style={commonStyles.fontBold}>{` ${getCSRAmount(
          cSRContribution
        )} `}</Text>
        /- From my payroll every month as my voluntary contribution towards CSR
        activities that CDK supports. I understand that this is purely voluntary
        in nature and can be modified anytime by me.
      </Text>
      <Text style={styles.mainText}>
        I further authorize the company to continue these deductions until
        further notice
      </Text>
      <Text>Sincerely</Text>
      <View style={styles.mainText}>
        <View style={styles.signature}>
          <Text style={commonStyles.textRed}>Signature:</Text>
          <Text style={styles.signatureSignLine}>
            {getFullName(candidateDetails)}
          </Text>
        </View>
        <View style={styles.signature}>
          <Text style={commonStyles.textRed}>Name:</Text>
          <Text style={styles.signatureNameLine}>
            {getFullName(candidateDetails)}
          </Text>
        </View>
        <View style={styles.signature}>
          <Text style={commonStyles.textRed}>Date:</Text>
          <Text style={styles.signatureDateLine}>
            {getFormattedDate(declarationDate)}
          </Text>
        </View>
        <View style={styles.signature}>
          <Text style={commonStyles.textRed}>Place:</Text>
          <Text style={styles.signaturePlaceLine}>
            {getDeclarationPlace(declarationPlace)}
          </Text>
        </View>
      </View>
      <Text style={styles.note}>Note:</Text>
      <View style={styles.list}>
        <Text style={styles.bulletPointContainer}>
          <Text style={styles.bulletPoint}>·</Text> Employees can modify /
          change / stop their contributions by logging on to IKARE.
        </Text>
        <Text>
          <Text style={styles.bulletPoint}>·</Text> A recurring minimum
          contribution of Rs. 100 with increments of Rs. 100 each can be made
          upto a maximum of
        </Text>
        <Text style={styles.listText}>Rs. 2500 per month</Text>
        <Text>
          <Text style={styles.bulletPoint}>·</Text> Contributions are used for
          supporting charities managed by United Way of Hyderabad and
          contributions made
        </Text>
        <Text style={styles.listText}>
          under the program qualify for 50% tax exemption under Section 80G of
          Income Tax Act.
        </Text>
      </View>
    </Page>
  );
});

export default CSRForm;
